var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02456 22.4232C5.55048 19.1563 8.58061 17 12 17C15.4195 17 18.4496 19.1563 19.9755 22.4232C20.2093 22.9236 20.8044 23.1398 21.3048 22.906C21.8052 22.6723 22.0213 22.0772 21.7876 21.5768C19.9835 17.7143 16.309 15 12 15C7.69105 15 4.01659 17.7143 2.21249 21.5768C1.97876 22.0772 2.19494 22.6723 2.69533 22.906C3.19572 23.1398 3.79084 22.9236 4.02456 22.4232Z",
    fill: "currentColor"
  })));
};
export default SvgProfile;